module.exports = __webpack_public_path__ + "static/media/texto.af93903c.jpg";